import { createStore } from '@stencil/store';
import { OnChangeHandler } from '@stencil/store/dist/types';
import { Business, CartItem, Category, Customer, CustomerCategory, CustomerSubCategory, GreenOptions, Product, RotOptions, RutOptions, Service, User, WpOptions } from '../types';
import { CreditSafeUser } from '../types/felixtypes';

type StateType = {
  step: number;
  selectedCategory: Category | null;
  selectedService: Service | null;
  selectedProduct: Product | null;
  cart: Array<CartItem>;
  business: Business | 'undefined';
  options: WpOptions | null;
  rut: boolean;
  rot: boolean;
  green: boolean;
  token: string | null;
  checkoutStep: number;
  checkoutEdit: boolean;
  user: User | null;
  creditSafeUser: CreditSafeUser | null;
  modal: {
    title?: string;
    text: string;
  } | null;
  rutOptions: RutOptions | null;
  rotOptions: RotOptions | null;
  greenOptions: GreenOptions | null;
  customer: Customer | null;
  selectedCustomerCategory: CustomerCategory | CustomerSubCategory | null;
  parentCategory: CustomerCategory | CustomerSubCategory;
  checkoutInvoice: boolean;
  maleri: boolean;
  selectSource: boolean;
  showSourcePasswordPrompt: boolean;
};

const {
  state,
  onChange,
}: {
  state: StateType;
  onChange: OnChangeHandler<StateType>;
} = createStore({
  step: 1,
  checkoutStep: 1,
  checkoutEdit: false,
  selectedCategory: null,
  selectedService: null,
  selectedProduct: null,
  cart: [],
  business: 'undefined',
  options: null,
  rut: true,
  rot: true,
  green: true,
  token: null,
  user: null,
  modal: null,
  rutOptions: null,
  rotOptions: null,
  greenOptions: null,
  customer: null,
  selectedCustomerCategory: null,
  parentCategory: null,
  creditSafeUser: null,
  checkoutInvoice: false,
  maleri: false,
  sources: null,
  selectSource: false,
  showSourcePasswordPrompt: false,
});

onChange('cart', cart => {
  window.sessionStorage.setItem(`hemfixarna-${state.business}-cart`, JSON.stringify(cart));
});

onChange('user', user => {
  window.sessionStorage.setItem(`hemfixarna-${state.business}-user`, JSON.stringify(user));
});

onChange('creditSafeUser', user => {
  window.sessionStorage.setItem(`hemfixarna-${state.business}-creditSafeUser`, JSON.stringify(user));
});

onChange('selectSource', selectSource => {
  if (selectSource) {
    localStorage.setItem('select_source', 'true');
  }
});

onChange('selectedProduct', product => {
  if (!state.customer || !product) return;
  const categories = [...state.customer.categories, ...state.customer.categories.map(c => c.sub_categories ?? [])].flat();
  const category = categories.find(c => c && c.id === product.category);
  if (category) {
    state.parentCategory = category;
    return;
  }
  state.parentCategory = null;
});

onChange('selectedCustomerCategory', category => {
  if (!state.customer || !category) return;
  if ((category as CustomerSubCategory).parent) {
    const parent = state.customer.categories.find(c => c.id === (category as CustomerSubCategory).parent);
    if (parent) {
      state.parentCategory = parent;
      return;
    }
  }
  state.parentCategory = null;
});

export default state;
